import React, { useState } from "react";
import "./silde-model.css";

interface SlideModalProps {
  slides: any[];
  handleCloseModal: () => void;
}

const SlideModal: React.FC<SlideModalProps> = ({
  slides,
  handleCloseModal,
}) => {
  slides = slides.filter(item =>
    item.type !== 'cpeForm' &&
    item.type !== 'video/mp4' &&
    item.type !== 'pollQuestions' &&
    item.type !== 'pollresult'
  );

  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [isHoveringPrev, setIsHoveringPrev] = useState<boolean>(false);
  const [isHoveringNext, setIsHoveringNext] = useState<boolean>(false);

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide < slides.length - 1 ? prevSlide + 1 : prevSlide
    );
  };

  const handlePreviousSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide > 0 ? prevSlide - 1 : prevSlide));
  };

  const current = slides[currentSlide];

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <div className="modalHeader">
          <button onClick={handleCloseModal} className="closeButton">
            &times;
          </button>
        </div>

        <div className="slideContent">
          {current.type === "image" && (
            <img
              crossOrigin="anonymous"
              src={current.url}
              alt={`Slide ${current.sequence}`}
              style={{ width: "100%", height: "auto" }}
            />
          )}
          {/* {current.type === "video/mp4" && (
            <video controls style={{ width: "100%", height: "auto" }}>
              <source src={current.url} type="video/mp4" />
            </video>
          )} */}
        </div>

        <button
          onMouseEnter={() => setIsHoveringPrev(true)}
          onMouseLeave={() => setIsHoveringPrev(false)}
          onClick={handlePreviousSlide}
          className={`navButton prevButton ${isHoveringPrev ? "hover" : ""}`}
        >
          &#8249;
        </button>
        <button
          onMouseEnter={() => setIsHoveringNext(true)}
          onMouseLeave={() => setIsHoveringNext(false)}
          onClick={handleNextSlide}
          className={`navButton nextButton ${isHoveringNext ? "hover" : ""}`}
        >
          &#8250;
        </button>
      </div>
    </div>
  );
};

export default SlideModal;
